import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { razonSocialActions } from '../../../application/actions/razonSocial';
import { sesionActions } from '../../../application/actions/sesion';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// Razon Social
export function* razonSocial(e) {
    console.log("AQUI",e.payload.razonSocial)
    yield put(razonSocialActions.conexionRazonSocial({conexion:true}));
    yield put(sesionActions.conexionSesion({conexion:true}));
    try {
        const  params  = e.payload;
        const url = `login/razonsocial`
        const response = yield call(
            apiRequest.post,
            url,
            params,
        );

        const  {data, result, message }   = response;
        if(result){
             // RazonSocial
            yield put(razonSocialActions.iniciarRazonSocial(e.payload.razonSocial));
            yield put(razonSocialActions.razonSocialSetId({id:data.idRazonsocial}));

            // Sesion
            //const {token } = data;
            sessionStorage.setItem('sesion', JSON.stringify(data));
            yield put(sesionActions.craerSesion(data));
        }else{
            yield put(razonSocialActions.errorRazonSocial({ error:true, message:message }));
            yield put(razonSocialActions.conexionRazonSocial({conexion:false}));
            yield put(sesionActions.conexionSesion({conexion:false}));
        }
    } catch (err) {

        yield put(razonSocialActions.conexionRazonSocial({conexion:false}));
        yield put(razonSocialActions.errorRazonSocial({error:true, message:err.message}));

        yield put(sesionActions.conexionSesion({conexion:false}));
        yield put(sesionActions.errorSesion({error:err.message}));

    } finally {
    }
}


export function* watchFetchRazonSocial() {
    yield takeLatest(razonSocialActionsSaga.activeRazonSocial.type, razonSocial);
}

export default function* rootSaga() {
    yield spawn(watchFetchRazonSocial);
}


const activeRazonSocial = createAction('reazonSocialSaga/activeRazonSocial');

export const razonSocialActionsSaga = {
    activeRazonSocial,
};
